import React from 'react';
import { connect } from 'react-redux';

import AlertBox from '../../modules/AlertBox';
import AlertMessage from '../../modules/AlertMessage';

class Page extends React.Component {

    render() {
        return (
            <div>
                <AlertMessage>
                    {this.props.requiresConfirmation && (
                        <AlertBox
                            theme="warning"
                        >
                            Your account requires confirmation, we sent you an email on how to do this.
                        </AlertBox>
                    )}
                </AlertMessage>

                { this.props.children }
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        requiresConfirmation: state.session.requiresConfirmation
    }
}

export default connect(mapStateToProps)(Page);